<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="'770px'"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :sampleSetCode="sampleSetCode"
          :evgSkuCode.sync="newSampleCode"
          :disabled="disabled"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer">
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.confirm()"
          style="width:80px;"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    evgSkuCode: { type: String, default: '' },
    sampleSetCode: { type: String, default: '' },
    baseInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      newSampleCode: '',
    }
  },
  methods: {
    close() {
      if (!this.disabled) this.$emit('close')
      this.$emit('update:visible', false)
    },

    handleClose(done) {
      if (this.disabled) {
        done()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  watch: {
    evgSkuCode: {
      handler(e) {
        this.newSampleCode = e
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #72767b;
  display: flex;
  margin-bottom: 12px;
  padding: 20px 20px 0;
}

::v-deep .el-drawer__body {
  flex: 1;
  overflow: auto;
}
</style>
